import { Box, TableCell } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

export const DataTableValue = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'alignRight',
})<{ alignRight?: boolean }>(({ alignRight }) => ({
    padding: '4px 8px',
    textAlign: alignRight ? 'right' : 'left',
}));

export const DataTableCell = styled(TableCell, {
    shouldForwardProp: (prop) => prop !== 'readonly' && prop !== 'error' && prop !== 'warning',
})<{ readonly?: boolean; error?: boolean; warning?: boolean }>(({ theme, readonly, error, warning }) => ({
    padding: 0,
    border: '1px solid rgba(224, 224, 224, 1)',
    backgroundColor: error
        ? alpha(theme.palette.error.main, 0.1)
        : warning
          ? alpha(theme.palette.warning.main, 0.1)
          : readonly
            ? '#f7f7f7'
            : 'transparent',
    ...(error && {
        '& .MuiInputBase-root': {
            backgroundColor: alpha(theme.palette.error.main, 0.1),
        },
    }),
    ...(warning && {
        '& .MuiInputBase-root': {
            backgroundColor: alpha(theme.palette.warning.main, 0.1),
        },
    }),
}));

export const DataTableHeadCell = styled(TableCell, {
    shouldForwardProp: (prop) => prop !== 'alignRight' && prop !== 'align',
})<{ alignRight?: boolean; align?: 'left' | 'center' | 'right' }>(({ alignRight, align }) => ({
    padding: 0,
    paddingLeft: '8px',
    paddingRight: '8px',
    fontSize: '0.9rem',
    textAlign: align || (alignRight ? 'right' : 'left'),
}));
